var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _g, _rect26, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneandNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 733,
    viewBox: "0 0 433 733",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.47,
    y: 0.0498047,
    width: 360.52,
    height: 732.71,
    rx: 38.99,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 180.96,
    y: 21.9297,
    width: 50.35,
    height: 10.22,
    rx: 3.87,
    fill: "#E5E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.71 32.8397C247.913 32.8397 250.51 30.243 250.51 27.0397C250.51 23.8365 247.913 21.2397 244.71 21.2397C241.507 21.2397 238.91 23.8365 238.91 27.0397C238.91 30.243 241.507 32.8397 244.71 32.8397Z",
    fill: "#E5E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.1 19.1401H303.83V24.1401C303.824 37.1591 293.269 47.7101 280.25 47.7101H148.67C135.651 47.7101 125.096 37.1591 125.09 24.1401V19.1401H86.37C70.5581 19.1401 57.74 31.9582 57.74 47.7701V685.05C57.74 700.862 70.5581 713.68 86.37 713.68H345.1C360.912 713.68 373.73 700.862 373.73 685.05V47.7701C373.73 31.9582 360.912 19.1401 345.1 19.1401Z",
    fill: "#ECF1F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.98 72.0498C86.4571 72.0498 81.98 76.527 81.98 82.0498V113.14C81.98 118.663 86.4571 123.14 91.98 123.14H123.07C128.593 123.14 133.07 118.663 133.07 113.14V82.0498C133.07 76.527 128.593 72.0498 123.07 72.0498H91.98ZM92.37 165.71C86.8471 165.71 82.37 170.187 82.37 175.71V206.8C82.37 212.323 86.8471 216.8 92.37 216.8H123.46C128.983 216.8 133.46 212.323 133.46 206.8V175.71C133.46 170.187 128.983 165.71 123.46 165.71H92.37ZM83.15 363.02C83.15 357.497 87.6271 353.02 93.15 353.02H124.24C129.763 353.02 134.24 357.497 134.24 363.02V394.11C134.24 399.633 129.763 404.11 124.24 404.11H93.15C87.6271 404.11 83.15 399.633 83.15 394.11V363.02ZM93.55 446.68C88.0271 446.68 83.55 451.157 83.55 456.68V487.77C83.55 493.293 88.0271 497.77 93.55 497.77H124.64C130.163 497.77 134.64 493.293 134.64 487.77V456.68C134.64 451.157 130.163 446.68 124.64 446.68H93.55ZM83.94 550.34C83.94 544.817 88.4171 540.34 93.94 540.34H125.03C130.553 540.34 135.03 544.817 135.03 550.34V581.43C135.03 586.953 130.553 591.43 125.03 591.43H93.94C88.4171 591.43 83.94 586.953 83.94 581.43V550.34ZM94.33 634C88.8071 634 84.33 638.477 84.33 644V675.09C84.33 680.613 88.8071 685.09 94.33 685.09H125.42C130.943 685.09 135.42 680.613 135.42 675.09V644C135.42 638.477 130.943 634 125.42 634H94.33Z",
    fill: "#D6D8E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 170.77,
    y: 75.7002,
    width: 107.04,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 170.77,
    y: 92.73,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 170.77,
    y: 109.76,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 171.16,
    y: 169.36,
    width: 107.04,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 171.16,
    y: 186.39,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 171.16,
    y: 203.41,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 82.76,
    y: 259.37,
    width: 51.09,
    height: 51.09,
    fill: "#D6D8E0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 171.56,
    y: 263.01,
    width: 107.04,
    height: 9.73,
    fill: "#D6D8E0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 171.56,
    y: 280.04,
    width: 176.37,
    height: 9.73,
    fill: "#D6D8E0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 171.56,
    y: 297.07,
    width: 176.37,
    height: 9.73,
    fill: "#D6D8E0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 356.67,
    width: 107.04,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 373.7,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 171.95,
    y: 390.73,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 450.33,
    width: 107.04,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 467.36,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 484.39,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 172.73,
    y: 543.99,
    width: 107.04,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 172.73,
    y: 561.02,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 172.73,
    y: 578.05,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 173.12,
    y: 637.65,
    width: 107.04,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 173.12,
    y: 654.68,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 173.12,
    y: 671.71,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "#D6D8E0"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 0.439941,
    y: 228.54,
    width: 431.8,
    height: 103.39,
    rx: 11,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.56,
    y: 258.34,
    width: 107.04,
    height: 9.73,
    rx: 4.865,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.56,
    y: 275.37,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.56,
    y: 292.4,
    width: 176.37,
    height: 9.73,
    rx: 4.865,
    fill: "white"
  }))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 83.55,
    y: 255.3,
    width: 51.09,
    height: 51.09,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116 298.82C115.26 300.247 114.032 301.362 112.54 301.96C111.658 302.282 110.729 302.458 109.79 302.48C108.775 302.554 107.756 302.429 106.79 302.11C105.503 301.604 104.399 300.722 103.62 299.58C102.851 298.438 102.232 297.201 101.78 295.9C101.476 295.251 101.349 294.534 101.41 293.82C102.2 293.723 102.92 293.317 103.41 292.69C103.701 292.058 103.719 291.335 103.46 290.69C103.4 290.49 103.34 290.3 103.27 290.12C103.12 289.68 102.6 288.85 102.96 288.48C103.32 288.11 104.16 288.12 104.49 287.97C105.468 287.385 106.512 286.919 107.6 286.58C108.586 286.448 109.589 286.513 110.55 286.77C110.681 286.791 110.807 286.839 110.92 286.91C111.046 287.015 111.14 287.154 111.19 287.31C111.47 287.99 111.63 288.74 111.85 289.44C112.042 290.174 112.421 290.846 112.95 291.39C113.407 291.778 113.924 292.088 114.48 292.31L115.82 292.92C116.055 293.013 116.269 293.153 116.45 293.33C116.621 293.572 116.725 293.855 116.75 294.15C116.998 295.747 116.736 297.381 116 298.82Z",
    fill: "#A0616A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M111.84 289.47C109.651 291.743 106.206 292.256 103.45 290.72C103.39 290.52 103.33 290.33 103.26 290.15C103.11 289.71 102.59 288.88 102.95 288.51C103.31 288.14 104.15 288.15 104.48 288C105.458 287.416 106.502 286.949 107.59 286.61C108.576 286.479 109.579 286.543 110.54 286.8C110.671 286.822 110.797 286.869 110.91 286.94C111.036 287.045 111.13 287.184 111.18 287.34C111.46 288.05 111.62 288.77 111.84 289.47Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.84 291.3C110.673 291.3 113.78 288.193 113.78 284.36C113.78 280.527 110.673 277.42 106.84 277.42C103.007 277.42 99.8999 280.527 99.8999 284.36C99.8999 288.193 103.007 291.3 106.84 291.3Z",
    fill: "#A0616A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.89 306.38H95.2301C94.2301 304.15 93.3301 301.91 92.3201 299.68C92.4279 299.15 92.6276 298.642 92.9101 298.18C93.2036 297.722 93.7062 297.441 94.2501 297.43C94.5401 297.43 94.8701 297.54 95.0801 297.33C95.2901 297.12 95.2201 296.95 95.3701 296.81C95.5201 296.67 95.8801 296.67 96.1601 296.69C96.7704 296.71 97.3495 296.42 97.7001 295.92C97.8072 295.734 97.9383 295.562 98.0901 295.41C98.3529 295.283 98.6384 295.208 98.9301 295.19C99.7401 295.01 100.22 294.19 100.83 293.68C101.129 293.342 101.6 293.213 102.03 293.35C102.128 293.401 102.213 293.472 102.28 293.56C102.444 293.812 102.556 294.094 102.61 294.39C102.972 296.051 103.894 297.537 105.22 298.6C106.648 299.679 108.487 300.055 110.223 299.622C111.959 299.189 113.407 297.993 114.16 296.37C114.643 295.162 114.921 293.881 114.98 292.58C114.98 292.51 114.98 292.47 114.98 292.41C115.804 292.206 116.676 292.378 117.36 292.88C118.024 293.389 118.734 293.834 119.48 294.21C120.37 294.56 121.48 294.56 122.09 295.21C122.35 295.47 122.53 295.83 122.86 295.99C123.065 296.071 123.281 296.121 123.5 296.14C124.632 296.446 125.559 297.258 126.01 298.34C126.734 299.945 127.206 301.652 127.41 303.4L127.89 306.38Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.05 273.1C101.567 273.491 101.157 273.966 100.84 274.5C100.244 275.483 99.4126 276.301 98.4201 276.88C98.0039 277.026 97.6249 277.261 97.3101 277.57C97.1554 277.805 97.0562 278.072 97.0201 278.35C96.8171 279.32 96.7132 280.309 96.7101 281.3C96.673 281.799 96.7553 282.299 96.9501 282.76C97.1501 283.18 97.5301 283.54 97.6001 284C97.6146 284.364 97.5742 284.728 97.4801 285.08C97.3841 285.458 97.5313 285.856 97.8501 286.08C98.0312 286.145 98.2191 286.188 98.4101 286.21C99.4101 286.43 99.7501 287.61 99.9001 288.58C100.24 288.58 100.39 288.17 100.47 287.85L101.47 283.2C101.59 282.7 101.77 282.11 102.28 281.94C102.629 281.865 102.991 281.865 103.34 281.94C104.72 282.06 105.88 280.99 107.23 280.69C107.665 280.608 108.108 280.582 108.55 280.61C109.61 280.61 110.85 281.1 111.08 282.09C111.08 282.25 111.14 282.45 111.29 282.53C111.444 282.575 111.607 282.575 111.76 282.53C112.43 282.46 112.83 283.22 113.03 283.84L113.73 286.11C113.84 286.45 114.02 286.86 114.39 286.9C114.74 286.898 115.035 286.637 115.08 286.29C115.095 285.951 115.048 285.612 114.94 285.29C114.61 283.81 115.12 282.29 115.43 280.8C115.74 279.31 115.79 277.6 114.75 276.45C114.37 276.04 113.87 275.73 113.52 275.29C113.17 274.85 113.01 274.38 112.67 273.97C111.312 272.779 109.617 272.038 107.82 271.85C105.815 271.673 103.802 272.109 102.05 273.1Z",
    fill: "#3F3D56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.84 306.38H90.05C90.3937 304.282 91.0089 302.239 91.88 300.3C91.9484 300.1 92.0613 299.919 92.21 299.77C92.242 299.735 92.2791 299.704 92.32 299.68C92.55 299.5 92.87 299.43 93.12 299.26C93.37 299.09 93.4 298.91 93.63 298.84C94.4956 298.819 95.3572 298.962 96.17 299.26C96.4001 299.286 96.6255 299.343 96.84 299.43C97.3471 299.711 97.7266 300.177 97.9 300.73C98.56 302.52 98.06 304.46 97.84 306.38Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneandNotifications);
export default __webpack_public_path__ + "static/media/PhoneandNotifications.4cc8761f.svg";
export { ForwardRef as ReactComponent };